let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kkaKL")).then(() => parcelRequire('4JLjC'));